import { makeStyles } from "@mui/styles";
export default makeStyles((theme) => ({
  container: {
    margin: "20px 0",
  },
}));
